
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
    "commitHash": "38da814ec2bb4e81c7ad5a45b6b183a4d0b8dc25",
    "version": "12.1.1"
};
